<template>
   <div>

       <div class="search-bar">
           <el-input
                   size="small"
                   v-model="searchParams.keyword"
                   placeholder="输入关键字进行过滤"
                   style="margin-bottom: 10px;"
           ></el-input>
       </div>

       <el-table
               :data="tableData"
               max-height="500"
               style="width: 100%">
           <el-table-column
                   prop="name"
                   label="功能名称"
                   >
           </el-table-column>

           <el-table-column
                   prop="type"
                   label="功能类型"
                   >
               <template slot-scope="scope">
                  <dict-text type-flag="ACTION_TYPE" :dict-value="scope.row.type"></dict-text>
               </template>
           </el-table-column>

           <el-table-column
                   fixed="right"
                   label="操作"
                   width="100">
               <template slot-scope="scope">
                   <el-switch v-model="scope.row.chosen" @change="handleChange(scope.row)"></el-switch>
               </template>
           </el-table-column>

       </el-table>
   </div>
</template>

<script>
    import DictText from "../DictText";
    export default {
        name: "ActionTable",
        components: {DictText},
        props:{
           moduleCode:{
               type:String,
               default:''
           },chosenActions:{
               type:Array,
               default:function () {
                   return [] ;
               }
           },
        },
        watch:{

            moduleCode(v){
                this.searchParams.moduleCode = v;
            },
            searchParams:{
               deep:true,
                handler:function () {
                    this.loadActions();
                }
            },
            chosenActions(){
                let vm = this;
                this.tableData.forEach((action)=>{
                    action.chosen = (vm.chosenActions.filter((a)=>{ return action.code === a.code}).length > 0)
                });
            },
        },
        data() {
            return {
                tableData: [],
                searchParams:{
                    keyword:'',
                    moduleCode:'',
                    onPage:false
                }
            }
        },
        methods:{
            handleChange(e){
                this.$emit('handleActionChange',e);
            },
           loadActions(){

               let vm = this;
               vm.$http.post(vm.$api.action.list,this.searchParams).then((resp)=>{

                   resp.data.data.actions.forEach((action)=>{
                       action.chosen = (vm.chosenActions.filter((a)=>{ return a.code === action.code}).length > 0)
                   });

                   vm.tableData = resp.data.data.actions;

               });

           }
        },
        created() {
            this.loadActions();
        }
    }
</script>

<style scoped>

</style>